import TChart from './echarts.vue'
export default TChart



// WEBPACK FOOTER //
// ./src/components/charts/index.js